import { render, staticRenderFns } from "./XtendGuide.vue?vue&type=template&id=8d21f6f8&"
import script from "./XtendGuide.vue?vue&type=script&lang=js&"
export * from "./XtendGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports